import { Button, ButtonGroup, FormControl, FormControlLabel, Grid, Input, MenuItem, Radio, RadioGroup, Select, TextField } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Autocomplete from '@mui/material/Autocomplete';
import React, { useEffect, useState } from 'react';
import { editEFG, vantagePath, searchFilter, handleSort } from "../utils/varialbles"
import { useHistory, useLocation } from "react-router-dom";
import http from "../services/httpService";
import toast, { Toaster } from 'react-hot-toast';
import handleValidation from '../utils/handleValidations';
import handleSubmitValidation from '../utils/handleSubmitValidation';
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        marginTop: "20px",
        marginBottom: 30
    },
    paper: {
        marginTop: 20
    },
    lableColor: {
        color: "#393939"
    },
    select: {
        height: 36,
        minWidth: 300,

    },
    radio: {
        '&$checked': {
            color: '#57bf74'
        }
    },
    submitButton: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(10),


    },
    checked: {}
}));




function AddTheme() {
    let form = {
        "Theme": "",
        "Sectors": "",
        "Status": false,
    }
    const validations = {
        "Theme": {
            conditions: {
                "required": true, "maxLength": 50
            }, "message": "Maximum 50 character Allowed.!", "valid": true, "changed": false
        },
        "Sectors": {
            conditions: {
                "required": true, "maxLength": 1000
            }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
        },

    }
    const [validationState, setValidationState] = useState(validations)
    const classes = useStyles();
    const history = useHistory();
    const [efgActive, setEfgActive] = useState(true);
    const [formObject, setFormObject] = useState(form);
    const [editTheme, setEditTheme] = useState(false);
    const location = useLocation();
    const myparam = location.state;
    const handleChange = (event, boolean) => {
        let name = event.target.name;
        let value = event.target.value;
        let valid = true;
        let validStateTemp = { ...validationState }

        if (boolean && value === 'false') {
            value = false
        } else if (boolean && value == 'true') {
            value = true
        }
        if (name && validStateTemp.hasOwnProperty(name)) {
            let validation = handleValidation(name, value, validStateTemp);

            setValidationState(validation.validStateTemp)
            valid = validation.valid
        }
        if (valid || value === "" || value == 0) {
            setFormObject({
                ...formObject,
                [event.target.name]: event.target.value
            });
        }
    }
    const gotoEFG = () => {
        history.push({
            pathname: vantagePath, state: { "tab": "EFG Admin", "subTab": "Theme Customization" }
        });
    }
    const handleCancel = () => {

        if (myparam && myparam.id) {
            setEditTheme(true);
            setFormObject({
                "Theme": myparam.Theme ? myparam.Theme : "",
                "Sectors": myparam.Sectors ? myparam.Sectors : "",
                "Status": myparam.Status,
            })
        } else {
            setFormObject(form);
        }
    }
    useEffect(() => {
        handleCancel()
    }, []);
    const handleSubmit = (e) => {
        e.preventDefault();
        let validStateTemp = { ...validationState }
        let validCount = 0;
        let finalObjet = { ...formObject };

        let validData = handleSubmitValidation(finalObjet, validStateTemp)
        validCount = validData.validCount;
        if (validCount === 0) {
            http.post("/themelist", formObject,
            ).then((response) => {
                if (response && response.data && response.data.id) {
                    toast.success("Theme Created Successfully");
                    gotoEFG()
                } else {
                    toast.error("Theme Created Failed");
                }
            }).catch((error) => {
                toast.error("Theme Created Failed");
            })
        } else {
            setValidationState(validData.validStateTemp);
            toast.error("Please check Errors in Field level!")
        }
    }
    const handleUpdate = (e) => {
        e.preventDefault();
        let validStateTemp = { ...validationState }
        let validCount = 0;
        let finalObjet = { ...formObject };
        let validData = handleSubmitValidation(finalObjet, validStateTemp)
        validCount = validData.validCount;
        if (validCount === 0) {
            if (myparam && myparam.id) {
                http.put("/themelistedit/" + myparam.id + "/", formObject,
                ).then((response) => {
                    if (response && response.data && response.data.id) {
                        toast.success("Theme Updated Successfully");
                        gotoEFG()
                    } else {
                        toast.error("Theme Updation Failed");
                    }
                    // history.push(vantagePath)
                }).catch((error) => {
                    toast.error("Theme Updation Failed");
                })
            }
        } else {
            setValidationState(validData.validStateTemp);
            toast.error("Please check Errors in Field level!")
        }
    }
    return (
        <div className={classes.root, "pb30"}>
            <AppBar position="static" style={{ marginBottom: 5, paddingTop: 3, paddingBottom: 3 }}>
                <Grid container component="main">
                    <Grid item xs={6} sm={6} md={6}>
                        <ButtonGroup>
                            <Button variant={efgActive ? "contained" : "outlined"} color="primary" style={{ marginLeft: 10, borderRadius: 60 }} name="archivedPostsButton" onClick={gotoEFG}>EFG Admin</Button>
                        </ButtonGroup>
                    </Grid>
                </Grid>
            </AppBar>
            <Grid container component="main" style={{ marginTop: 30 }}>
                <Grid item xs={false} sm={5} md={5} >
                    {/* <Button variant="outlined" color="default" startIcon={<ArrowBackIosIcon />} onClick={history.goBack}>Back</Button> */}
                </Grid>
                <Grid item xs={false} sm={5} md={5}  >
                    <Typography color="textPrimary" variant="h5" >Investment Theme Manager - {editTheme ? "Edit" : "Add"} Theme</Typography>
                </Grid>

                <Grid container className={classes.paper} style={{ marginTop: 30 }}>
                    <Grid item xs={false} sm={2} md={2} className={"formLable"}>
                        <InputLabel id="themeLable" className={classes.lableColor}>Theme <span style={{ color: 'red', fontSize: '1.2rem', marginLeft: '0.2rem' }}>*</span></InputLabel>
                    </Grid>

                    <Grid item xs={12} sm={5} md={5} >
                        <TextField id="ThemeField" label="Enter" variant="outlined" className={classes.select} name="Theme" value={formObject.Theme} onChange={handleChange}
                            style={validationState.hasOwnProperty("Theme") && validationState["Theme"]['changed'] && !validationState["Theme"]['valid'] ? { paddingBottom: 20 } : {}}
                            error={validationState["Theme"]['changed'] && !validationState["Theme"]['valid']} helperText={validationState["Theme"]['changed'] && !validationState["Theme"]['valid'] ? validationState["Theme"]['message'] : ""}
                        />
                    </Grid>
                </Grid>
                <Grid container className={classes.paper} >
                    <Grid item xs={12} sm={2} md={2} className={"formLable"}>
                        <InputLabel id="SectorsLabel" className={classes.lableColor}>Sectors <span style={{ color: 'red', fontSize: '1.2rem', marginLeft: '0.2rem' }}>*</span></InputLabel>
                    </Grid>

                    <Grid item xs={12} sm={5} md={5}>
                        <TextField id="SectorsField" label="Enter" variant="outlined" className={classes.select} name="Sectors" value={formObject.Sectors} onChange={handleChange}
                            style={validationState.hasOwnProperty("Sectors") && validationState["Sectors"]['changed'] && !validationState["Sectors"]['valid'] ? { paddingBottom: 20 } : {}}
                            error={validationState["Sectors"]['changed'] && !validationState["Sectors"]['valid']} helperText={validationState["Sectors"]['changed'] && !validationState["Sectors"]['valid'] ? validationState["Sectors"]['message'] : ""}
                        />
                    </Grid>
                </Grid>
                <Grid container className={classes.paper} >
                    <Grid item xs={12} sm={2} md={2} className={"formLable"}>
                        <InputLabel id="StatusLabel" className={classes.lableColor}>Status <span style={{ color: 'red', fontSize: '1.2rem', marginLeft: '0.2rem' }}>*</span></InputLabel>
                    </Grid>

                    <Grid item xs={12} sm={5} md={5} >
                        <FormControl component="fieldset">
                            <RadioGroup row aria-label="position" name="Status" value={(formObject.Status) ? formObject.Status : false} onChange={e => handleChange(e, true)}>
                                <FormControlLabel
                                    control={<Radio classes={{ root: classes.radio, checked: classes.checked }} value={true} />}
                                    label="Active"
                                    labelPlacement="end"
                                />
                                <FormControlLabel
                                    control={<Radio classes={{ root: classes.radio, checked: classes.checked }} value={false} />}
                                    label="Inactive"
                                    labelPlacement="end"
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.submitButton}>
                    <Grid item xs={12} sm={2} md={2} >
                    </Grid>
                    <Grid item xs={12} sm={1} md={1} >
                        <Button variant="outlined" color="primary" onClick={handleCancel} className="addBtn">Cancel</Button>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2} >
                        {
                            editTheme ? <Button variant="contained" color="primary" onClick={handleUpdate} className="addBtn">Update Theme</Button> :
                                <Button variant="contained" color="primary" onClick={handleSubmit} className="addBtn">Add Theme</Button>
                        }

                    </Grid>
                </Grid>
            </Grid>
        </div>
    )


}

export default AddTheme;
